import React from 'react';
import PropTypes from 'prop-types';
import NavigationRow from './NavigationRow';
import NavigationRowExpandImg from './styled/NavigationRowExpandImg';

const NewInSaleNavigation = ({ s3BasePath, values, handleClick }) => (
  <>
    <NavigationRow
      text="new in"
      handleClick={() => handleClick(values, { name: 'New In', applyQueryParams: 'applyNewIn' })}
    >
      <NavigationRowExpandImg src={`${s3BasePath}mkt/icon/plus_black.png`} />
    </NavigationRow>
    <NavigationRow
      red
      text="sale"
      handleClick={() => handleClick(values, { name: 'Sale', applyQueryParams: 'applySale' })}
    >
      <NavigationRowExpandImg src={`${s3BasePath}mkt/icon/plus_black.png`} />
    </NavigationRow>
  </>
);

NewInSaleNavigation.propTypes = {
  s3BasePath: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      sub: PropTypes.array,
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default NewInSaleNavigation;
